function pushEvent(event) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
}
function pushEcommerceEvent(event) {
    // Make sure we clear the previous ecommerce object
    pushEvent({
        event: '',
        atfEcommerce: null
    });
    pushEvent(event);
}

export { pushEcommerceEvent, pushEvent };
//# sourceMappingURL=helpers.js.map
